import {Component, Injector, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {InformationDialog} from "../../_shared/dialog/information.dialog";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent extends BaseComponentDirective implements OnInit {
  submitted = false;
  form: FormGroup = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
  });

  get f() {
    return this.form.controls;
  }

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  onSubmit(): void {

    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    const dialog = this.dialog.open(ConfirmationDialog, {
      data: {
        message: 'Sending Reset Password Email',
        subMessage: 'A password reset email will be sent to your inbox.',
        buttonCancelLabel: 'Cancel',
        buttonOkLabel: 'OK'

      }
    });
    dialog.componentInstance.result.subscribe(r => {
      this.submitted = true;
      const { email } = this.form.value;
      this.authService.forgotPassword(email).then((_) => {
        this.submitted = false;
        const dialog2 = this.dialog.open(InformationDialog, {
          data: {
            message: 'Email Sent!',
            subMessage: 'Please check your email inbox for your generated password.',
          }
        })

        dialog2.componentInstance.result.subscribe(r => {
          if(r) {
            this.router.navigateByUrl('/login').then();
          }
        })

      });
    })

  }
}
